/** Shown above `permission_hint` when a building search is blocked. */
export const BUILDING_ACCESS_DENIED_LEAD = "Access denied — you can't search here yet.";

/** Safe exterior copy when the player may enter but has not searched inside yet. */
export const BUILDING_EXTERIOR_ENTER_PROMPT = "You can go inside to search.";

/** Bottom HUD when standing beside an outdoor entry chevron (no story spoilers). */
export function buildingEntryArrowInteractHint(permitted: boolean): string {
  return permitted ? "Enter — tap or E" : "Can't enter — tap or E";
}
